import React, { useEffect } from 'react';
import { Box, Typography, Grid, Container } from '@mui/material';
import AOS from 'aos';
import 'aos/dist/aos.css';

const CompanyProfile = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with animation duration and trigger-once behavior
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 4, overflow: "hidden" }}>
      <Grid container spacing={4} alignItems="center">
        {/* Left Side - Logo Images */}
        <Grid item xs={12} md={5}>
          <Box sx={{ position: 'relative', minHeight: '400px' }}>
            {/* CGL Logo Image */}
            <Box
              component="img"
              src="https://i.postimg.cc/65Z6cDsZ/2ffbe5f7545947a79cfc489cd45e8c3d-1.png"
              alt="CGL Logo"
              sx={{
                position: 'absolute',
                top: '10%',
                left: '10%',
                width: '150px', // Same width
                height: '150px', // Same height
                transform: 'rotate(-10deg)',
                border: '3px solid green',
                transition: 'transform 0.3s, box-shadow 0.3s',
                '&:hover': {
                  transform: 'rotate(-10deg) scale(1.1)',
                  boxShadow: '0 0 10px rgba(0, 128, 0, 0.6)',
                },
              }}
            />

            {/* My Food Logo Image */}
            <Box
              component="img"
              src="https://i.postimg.cc/4xNfGn76/4616a9d6cb8cdb50b82ec883df1bb6ad.png"
              alt="My Food Logo"
              sx={{
                position: 'absolute',
                top: '30%',
                right: '5%',
                width: '150px', // Same width
                height: '150px', // Same height
                transform: 'rotate(5deg)',
                border: '3px solid green',
                transition: 'transform 0.3s, box-shadow 0.3s',
                '&:hover': {
                  transform: 'rotate(5deg) scale(1.1)',
                  boxShadow: '0 0 10px rgba(0, 128, 0, 0.6)',
                },
              }}
            />

            {/* Son-X Logo Image */}
            <Box
              component="img"
              src="https://i.postimg.cc/5tKjTLsQ/cc4330046b87e0f16a77d28f29080910.png"
              alt="Son-X Logo"
              sx={{
                position: 'absolute',
                bottom: '10%',
                left: '25%',
                width: '150px', // Same width
                height: '150px', // Same height
                border: '3px solid green',
                transition: 'transform 0.3s, box-shadow 0.3s',
                '&:hover': {
                  transform: 'scale(1.1)',
                  boxShadow: '0 0 10px rgba(0, 128, 0, 0.6)',
                },
              }}
            />
          </Box>
        </Grid>

        {/* Right Side - Content with AOS Animation */}
        <Grid item xs={12} md={7}>
          <Box sx={{ p: 3 }} data-aos="fade-left">
            <Typography
              variant="h4"
              sx={{
                color: '#8ab84d',
                fontWeight: 'bold',
                mb: 4,
                fontFamily: '"Montserrat", sans-serif',
              }}
            >
              We help to make trading products easy
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: '#666',
                lineHeight: 1.8,
              }}
            >
              CGL General Trading, based in Dubai, stands as a prominent player
              in the food and beverage import industry, specializing in B2B
              transactions. Our primary focus is on sourcing high-quality
              products from India, and we proudly own and market our own brand,
              Son X. With an extensive product portfolio, we offer essential
              commodities such as coconut oil, olive oil, tamarind, vegetable
              pickles, lemon pickles, mango pickles, as well as hand wash and
              dish wash liquids.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CompanyProfile;
